<template>
  <div>
    <span class="ml-5">{{name}}</span>
    <el-tooltip
      v-if="showExternalLink"
      placement="top"
      content="Accéder au détail du produit dans Datagrapes.io"
    >
      <a
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        class="ml-5 datagrapes-link"
      >
        <img src="@/assets/images/datagrapes.svg" alt="Datagrapes" class="datagrapes-logo" />
      </a>
    </el-tooltip>
  </div>
</template>
<script>

import ProductUtil from '@/utils/product-util'

export default {
  name: 'Inventory-product-tile',
  props: {
    product: {
      type: Object,
      default: null,
    },
    vintage: {
      type: String,
      default: null
    },
    inventoryCode : {
      type: String,
      default: null
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {

	},
	computed: {
    showExternalLink () {
      return this.inventoryCode === 'SAQ';
    },
    link (){
      return `https://app.datagrapes.io/products/${this.productExternalId}/synthesis`;
    },
    productExternalId (){
      return _.get(this.product, 'externalId');
    },
    name(){
      return this.product.extendedName;
    },
	},
	watch : {

	},
	mounted(){

	},
	created(){

	}
}
</script>

<style lang="scss" scoped>
.datagrapes-link {
  display: inline-flex;
  align-items: center;
}

.datagrapes-logo {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

</style>
